import React from "react";
import { motion } from "framer-motion";
import { Link, graphql } from "gatsby";
import Img from "gatsby-image";
import BackgroundImage from "gatsby-background-image";
import Layout from "../components/layout";
import CustomerAdviser from "../components/vectors/CustomerAdviser";
import Vehicles from "../components/vectors/vehicles";
import TempVehicles from "../components/vectors/tempVehicles";
import Team from "../components/vectors/Team";
import Installation from "../components/vectors/installation";
import SameDay from "../components/vectors/sameDay";

import "../styles/global.scss";


export default function Home({ data }) {
  return (
    <Layout>
      <BackgroundImage
        fluid={data.collectionOfVans.childImageSharp.fluid}
        alt="collection of vans"
        className="masthead"
        loading='eager'
      >
        <div className="blue-overlay">
          <h1>The UK's Same-day Delivery Specialists</h1>
          <h2>HASLAM LOGISTICS</h2>
          <a href="#services" rel="noreferrer">More Info</a>

          <div className="statements">
            <motion.p
            animate={{scale: [1, 1.5, 1]}}
            transition={{delay: 1.5}}
            >60 Min Pick Up Time.</motion.p>
            <motion.p
             animate={{scale: [1, 1.5, 1]}}
            transition={{delay: 2.5}}
            >24 / 7 / 365 Availability.</motion.p>
            <motion.p
             animate={{scale: [1, 1.5, 1]}}
            transition={{delay: 3.5}}
            >Nationwide Coverage.</motion.p>
          </div>
        </div>
      </BackgroundImage>

      <div className="home-page">
        <section className="vector-services">
          <h3>Our Services</h3>
          <a name="services"></a>
          <div className="serv-wrapper">
            <div className="top-row">
              <div className="home-service">
                <Vehicles />
                <h4>24 / 7 / 365 Courier Services</h4>
                <p>
                  Our GPS fitted vehicles are always available to make sure all
                  consignments, small or large, reach quickly and safely.
                </p>
              </div>
              <div className="home-service">
                <SameDay />
                <h4>60 minute collection + Same-day delivery</h4>
                <p>
                  We are the UK’s same-day courier specialists. From collection
                  within 60 minutes to same-day delivery. Perfect for when you
                  need that item as soon as possible.
                </p>
              </div>
              <div className="home-service">
                <TempVehicles />
                <h4>Temperature controlled transport</h4>
                <p>
                  Use our temperature regulated vehicles for the best in thermal
                  sensitive transport. The best choice for pharmaceutical and
                  vaccine transport.
                </p>
              </div>
            </div>
            <div className="bottom-row">
              <div className="home-service">
                <Team />
                <h4>Two man teams + white glove services</h4>
                <p>
                  Our two-man teams and white-glove services are available
                  around the clock.
                </p>
              </div>
              <div className="home-service">
                <Installation />
                <h4>Installations</h4>
                <p>Installations for retail, ePOS systems, signage and more.</p>
              </div>
              <div className="home-service">
                <CustomerAdviser />
                <h4>Bespoke Operations</h4>
                <p>
                  Friendly advisers can help tailor make a bespoke experience
                  for trickier jobs.
                </p>
              </div>
            </div>
          </div>

        </section>

        <div className="page-breaker">
          <h4>Anything. Anytime. Anywhere.</h4>
          <p>
            As specialists of same day courier services, our nationwide fleet
            will bring what you need, when you need it, to where you need it in
            the UK.
          </p>
          <p>
            Haslam Logistics is proud to provide exceptional service in all of
            our operations.
          </p>
        </div>

        <section className="info">
          <div className="block">
            <div className="text-l">
              <h4>
                We’re dedicated to providing high quality logistical solutions
                and services across the United Kingdom.
              </h4>
              <p>
                We believe in offering the highest standard of same-day courier
                service possible. As specialists in urgent, express, and rush
                courier deliveries throughout the UK, you can be confident that
                we’ll take care of your items.
                <br />
                We’ve been trusted by some of the biggest names in the country
                so you know you can expect a professional and efficient service
                every time.
              </p>
            </div>
            <div className="img-r">
              <Img
                fluid={data.rangeOfVans.childImageSharp.fluid}
                alt="range of courier vehicles"
              />
            </div>
          </div>
          <div className="block">
            <div className="img-l">
              <Img
                fluid={data.menCheckingBoxes.childImageSharp.fluid}
                alt="couriers checking boxes"
              />
            </div>
            <div className="text-r">
              <h4>Around the clock availability</h4>
              <p>
                We guarantee to always have a delivery vehicle available 24 / 7
                / 365 days a year.
                <br />
                Our nationwide network of depots and offices means that we can
                make the majority of collections within 60 minutes of the order
                being placed. DGSA, WEEE, FORS and other specialist drivers and
                vehicles are available. Simply get in contact to see which one
                is right for you.
                <br />
                You can rely on us to handle even the most complicated logistic
                challenges efficiently.
              </p>
            </div>
          </div>
          <div className="block">
            <div className="text-l">
              <h4>Additional services</h4>
              <p>
                Haslam Logistics also offer retail installations solutions.
                <br />
                Our experienced team has already been trusted by global brands
                for retail installations including single display installations,
                COVID-19 protective shielding, electronic Point of sale (ePOS)
                system installations, visual merchandising, and more.
                <br />
                Have a quick chat with us to get started.
              </p>
            </div>
            <div className="img-r">
              <Img
                fluid={data.smilingWorkmen.childImageSharp.fluid}
                alt="smiling workmen"
              />
            </div>
          </div>
        </section>

        <div className="page-breaker">
          <p className="q">
            Can't find what you're looking for? We can probably help.
          </p>
            <Link to='/contact'>Get in touch</Link>
        </div>

        <section className="businesses">
          <h3>Some of the brands that trust us</h3>

          <div class="slider">
            <div class="slide-track">
	          	<div class="slide">
                <Img fluid={data.amazon.childImageSharp.fluid} alt='amazon logo' />

	          	</div>
	          	<div class="slide">
                <Img fluid={data.starbucks.childImageSharp.fluid} alt='starbucks logo' />

		</div>
		<div class="slide">
    <Img fluid={data.debenhams.childImageSharp.fluid} alt='debenhams logo' />

		</div>
		<div class="slide">
    <Img fluid={data.citylink.childImageSharp.fluid} alt='citylink logo' />

		</div>
		<div class="slide">
    <Img fluid={data.hsbc.childImageSharp.fluid} alt='hsbc logo' />

		</div>
		<div class="slide">
    <Img fluid={data.jl.childImageSharp.fluid} alt='john lewis logo' />

		</div>
		<div class="slide">
    <Img fluid={data.ms.childImageSharp.fluid} alt='marks and spencer logo' />

		</div>
		<div class="slide">
    <Img fluid={data.o2.childImageSharp.fluid} alt='o2 logo' />

		</div>
		<div class="slide">
    <Img fluid={data.experts.childImageSharp.fluid} alt='expert installations logo' />

		</div>
		<div class="slide">
    <Img fluid={data.natwest.childImageSharp.fluid} alt='natwest logo' />
     
		</div>
		<div class="slide">
    <Img fluid={data.chanel.childImageSharp.fluid} alt='chanel logo' />

		</div>
		<div class="slide">
    <Img fluid={data.morrisons.childImageSharp.fluid} alt='morrisons logo' />

		</div>
		<div class="slide">
    <Img fluid={data.speedyFreight.childImageSharp.fluid} alt='speedy freight logo' />

		</div>
	
	</div>
</div>
          
            <h3>What our customers say</h3>
          <div className="reviews">

            

            <div className="review">
              <p className="testimonial">
                Haslam logistics has managed several deliveries and collections
                for me this year. Service was brilliant and communication was
                great. I would definitely recommend.
              </p>
              <p className="author">Fabian S</p>
            </div>

        

            <div className="review">
              <p className="testimonial">
                I had a very high priority job today between 2 of the UK's
                biggest airports for a huge client of mine. Haslam Logistics
                completed this job flawlessly. I am incredibly impressed with
                the service I have received and would highly recommend Haslam
                for your urgent high priority shipments.
              </p>
              <p className="author">Tom Backhouse</p>
            </div>

            <div className="review">
              <p className="testimonial">
                Absolutely fantastic service from start to finish. Prompt
                collection and delivery, great communications and a friendly
                manner. Will be using again soon. 10/10
              </p>
              <p className="author">Jack Whelan</p>
            </div>

            <div className="review">
              <p className="testimonial">
                Had to have a parcel delivered in an emergency to a business
                client so the samples can be examined. Haslam Logistics
                delivered the samples on the day which was requested by us. They
                are professional and offer a efficient service with great value.
                Very pleased, will be using them again. Keep up the good work
                guys.
              </p>
              <p className="author">Philip Ajayi</p>
            </div>

           

            

            

           
          </div>
        </section>
        <div className="stars">
        <Img fluid={data.stars.childImageSharp.fluid} alt='review stars' />
          
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query {
    collectionOfVans: file(relativePath: { eq: "Collection of vans.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    rangeOfVans: file(relativePath: { eq: "same-day-couriers-service.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    menCheckingBoxes: file(relativePath: { eq: "Men checking boxes.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }
    smilingWorkmen: file(relativePath: { eq: "smiling workmen.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }


    asda: file(relativePath: { eq: "business logos/asda.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    hsbc: file(relativePath: { eq: "business logos/hsbc.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    amazon: file(relativePath: { eq: "business logos/amazon.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    o2: file(relativePath: { eq: "business logos/o2.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    ms: file(relativePath: { eq: "business logos/ms.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    ncr: file(relativePath: { eq: "business logos/ncr.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    tesco: file(relativePath: { eq: "business logos/tesco.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    starbucks: file(relativePath: { eq: "business logos/starbucks.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    gps: file(relativePath: { eq: "business logos/gps.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    experts: file(relativePath: { eq: "business logos/expertinstallations.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    citylink: file(relativePath: { eq: "business logos/citylink.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    carpetright: file(relativePath: { eq: "business logos/carpetright.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    debenhams: file(relativePath: { eq: "business logos/debenhams.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }


    chanel: file(relativePath: { eq: "business logos/chanel.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    speedyFreight: file(relativePath: { eq: "business logos/speedy freight.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    morrisons: file(relativePath: { eq: "business logos/morrisons.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    natwest: file(relativePath: { eq: "business logos/natwest.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }

    jl: file(relativePath: { eq: "business logos/jl.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }


    stars: file(relativePath: { eq: "stars.jpg" }) {
      childImageSharp {
        fluid(maxWidth: 800) {
          ...GatsbyImageSharpFluid_noBase64
        }
      }
    }










  }
`;

